module.exports = __webpack_public_path__ + "static/media/instagram.e70e0bba.svg";